<template>
  <a-drawer width="55vw" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item :label="this.$t('店铺分类.分类名称')" prop="categoryName">
        <a-input
          v-model="form.categoryName"
          :maxLength="16"
          :placeholder="$t('通用.输入.请输入') + $t('店铺分类.分类名称')"
        />
      </a-form-model-item>

      <!--多语言集成-->
      <a-form-item
        v-if="form.localeList.length > 0"
        :label="this.$t('通用.文本.多语言配置')"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 20 }"
        class="margin-bottom-10"
      >
        <a-table :data-source="form.localeList" :columns="localeColumns" rowKey="id" :pagination="false" bordered>
          <span slot="locale" slot-scope="text, record">
            <custom-dict-tag :options="customDict.LocaleEnum" :value="record.locale" />
          </span>
          <div slot="name" slot-scope="text, record">
            <a-input
              v-model="record.name"
              :maxLength="16"
              :placeholder="$t('通用.输入.请输入') + $t('主营行业.分类名称')"
              @blur.native.capture="validatorLocaleName"
            />
          </div>
          <div slot="action" slot-scope="text, record">
            <a-button type="primary" @click="getTranslation(record)">
              {{ $t('通用.按钮.翻译') }}
            </a-button>
          </div>
        </a-table>
        <span style="color: red">{{ errorMessage }}</span>
      </a-form-item>
      <!--多语言集成-->

      <a-form-model-item :label="this.$t('店铺分类.分类图片')" prop="categoryPic">
        <a-upload
          name="categoryPic"
          listType="picture-card"
          :multiple="false"
          :show-upload-list="false"
          :preview="handlePreview"
          :before-upload="beforeOssUpload"
          :customRequest="coverImgUpload"
        >
          <img v-if="form.categoryPic" :src="form.categoryPic" alt="categoryPic" style="height: 200px; width: 200px" />
          <div v-else>
            <a-icon :type="loading ? 'loading' : 'plus'" />
            <div class="ant-upload-text">{{ $t('通用.按钮.上传') }}</div>
          </div>
        </a-upload>
        <span>推荐尺寸 60 x 60</span>
      </a-form-model-item>

      <a-form-model-item :label="this.$t('店铺分类.上级分类')" prop="pid">
        <a-tree-select
          v-model="form.pid"
          style="width: 100%"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          :tree-data="cateOptions"
          :placeholder="this.$t('通用.文本.请选择') + this.$t('店铺分类.上级分类')"
          :replaceFields="{ children: 'children', title: 'categoryName', key: 'id', value: 'id' }"
          tree-default-expand-all
        >
        </a-tree-select>
      </a-form-model-item>

      <a-form-model-item :label="this.$t('店铺分类.是否显示')" prop="isVisible">
        <a-radio-group v-model="form.isVisible" button-style="solid">
          <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>

      <a-form-model-item :label="$t('通用.文本.排序')" prop="sort">
        <a-input-number
          :maxLength="6"
          style="width: 50%"
          @change="limitSort"
          v-model="form.sort"
          :placeholder="$t('通用.输入.请输入') + $t('通用.文本.排序')"
        />
      </a-form-model-item>

      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video
          style="width: 100%"
          :src="previewUrl"
          ref="myVideo"
          :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'"
          :controls="true"
        ></video>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('通用.按钮.保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('通用.按钮.取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getShopCategory, addShopCategory, updateShopCategory, listShopCategory } from '@/api/shop/shopCategory'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'
import { generateFilePath, uploadObject, uploadOss } from '@/api/tool/oss'
//多语言配置
import { translation } from '@/api/tool/common'
//多语言配置
export default {
  name: 'CreateForm',
  props: {},
  components: {
    CustomDictTag,
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      cateOptions: [],
      // 表单参数
      form: {
        id: null,

        categoryName: null,

        categoryPic: null,

        pid: null,

        level: null,

        isVisible: null,

        isFilter: null,

        isHomeVisible: null,

        sort: null,

        createTime: null,

        remark: null,
        // 多语言集成
        localeList: [],
        // 多语言集成
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        categoryName: [
          { required: true, message: this.$t('店铺分类.分类名称') + this.$t('通用.文本.不能为空'), trigger: 'blur' },
        ],
        categoryPic: [
          {
            required: true,
            message: this.$t('店铺分类.店铺分类图片') + this.$t('通用.文本.不能为空'),
            trigger: 'blur',
          },
        ],
        level: [
          { required: true, message: this.$t('店铺分类.分类等级') + this.$t('通用.文本.不能为空'), trigger: 'blur' },
        ],
        isVisible: [
          { required: true, message: this.$t('店铺分类.是否显示') + this.$t('通用.文本.不能为空'), trigger: 'blur' },
        ],
        isFilter: [
          {
            required: true,
            message: this.$t('店铺分类.是否参与筛选(预留)') + this.$t('通用.文本.不能为空'),
            trigger: 'blur',
          },
        ],
      },
      //多语言集成
      errorMessage: undefined,
      localeColumns: [
        {
          title: this.$t('通用.文本.语言'),
          dataIndex: 'locale',
          key: 'locale',
          scopedSlots: { customRender: 'locale' },
        },
        {
          title: this.$t('主营行业.分类名称'),
          dataIndex: 'name',
          scopedSlots: { customRender: 'name' },
          key: 'name',
        },
        {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'action',
          key: 'action',
          slots: { title: 'addbtn', customRender: 'brandName' },
          scopedSlots: { customRender: 'action' },
        },
      ],
      //多语言集成
    }
  },
  filters: {},
  created() {},
  //多语言集成
  computed: {
    ...mapGetters(['customDict']),
  },
  //多语言集成
  watch: {},
  mounted() {},
  methods: {
    onClose() {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    previewVideoCancel() {
      this.previewVideoVisible = false
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.cateOptions = []
      this.form = {
        id: null,
        categoryName: null,
        categoryPic: null,
        pid: null,
        level: null,
        isVisible: null,
        isFilter: null,
        isHomeVisible: null,
        sort: null,
        createTime: null,
        remark: null,
        //多语言集成
        localeList: [],
        //多语言集成
      }
    },
    getCateList() {
      /*这个方法是树的写法*/
      listShopCategory().then((response) => {
        const cate = { id: '0', categoryName: this.$t('通用.文本.根节点'), children: [] }
        cate.children = this.handleTree(response.data, 'id', 'pid')
        this.cateOptions.push(cate)
      })
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.getCateList()
      this.form.isFilter = false
      this.form.isHomeVisible = true
      this.form.pid = '0'
      this.form.isVisible = true
      this.formType = 1
      this.open = true
      //多语言集成
      this.initLocale()
      //多语言集成
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.getCateList()
      this.formType = 2
      const id = row ? row.id : ids
      getShopCategory({ id: id }).then((response) => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    limitSort(sort) {
      console.log(sort)
      let val = sort
      if (val == null || val == undefined || val == '' || val < 0) {
        val = 0
      }
      if (val > 999999) {
        val = 999999
      }
      this.form.sort = val
    },
    // oss 上传开始
    async handlePreview(file) {
      let suffix = file.name.substring(file.name.lastIndexOf('.'))
      if (suffix === '.mp4') {
        this.handleVideoPreview(file)
      } else {
        this.handleImagePreview(file)
      }
    },

    async handleVideoPreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewUrl = file.url || file.preview
      this.previewVideoVisible = true
    },
    async handleImagePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewUrl = file.url || file.preview
      this.previewImageVisible = true
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = (error) => reject(error)
      })
    },
    // 上传之前校验
    beforeOssUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 20
      // if (!isJPG) {
      //     this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 20MB!')
      }
      return isLt2M
    },
    // 上传覆盖默认的上传行为
    coverImgUpload(file, index) {
      const _this = this
      // 获取文件对象
      const uploadFile = file.file
      // 文件夹目录
      const prefix = 'cate'
      const url = uploadOss(uploadFile.name, prefix)
      _this.$nextTick(() => {
        uploadObject(url, uploadFile).then((res) => {
          _this.$set(_this.form, 'categoryPic', res)
          _this.$message.success(this.$t('通用.文本.上传成功'))
        })
      })
    },
    // oss 上传结束
    //多图上传开始
    getUidRandom() {
      return Math.round(Math.random() * 80 + 20)
    },
    // 上传详情覆盖默认的上传行为
    coverImgCaseUploadInfo(file, index) {
      const _this = this
      // 获取文件对象
      const uploadFile = file.file
      // 文件夹目录
      const prefix = 'advert'
      const url = uploadOss(uploadFile.name, prefix)
      _this.$nextTick(() => {
        uploadObject(url, uploadFile).then((res) => {
          _this.imgCaseList.push({ status: 'done', url: res, uid: this.getUidRandom(), name: res })
          console.log(_this.imgCaseList)
          this.form.imgCaseList = []
          _this.imgCaseList.forEach((e) => {
            if (e.url !== undefined && e.url !== null && e.url !== '') {
              this.form.imgCaseList.push(e.url)
            }
          })
          _this.$message.success('上传成功')
        })
      })
    },
    // 删除图片
    removeImgCaseFile(file) {
      var fileList = []
      this.imgCaseList.forEach((e) => {
        if (e.url !== file.url) {
          fileList.push(e)
        }
      })
      var imgCaseList = []
      this.imgCaseList = fileList
      fileList.forEach((e) => {
        imgCaseList.push(e.url)
      })
      this.form.imgCaseList = imgCaseList
    },
    //多图上传结束
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          let message = ''
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateShopCategory(this.form)
              .then((response) => {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          } else {
            message = this.$t('通用.文本.修改成功')
            addShopCategory(this.form)
              .then((response) => {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          }
        } else {
          return false
        }
      })
    },
    //多语言集成
    initLocale() {
      //获取全局配置的语言
      const sysLangList = globalThis.$openLangList
      //初始化多语言
      let localeList = []
      let i = 1
      this.customDict.LocaleEnum.forEach((e) => {
        if (sysLangList.includes(e.type)) {
          localeList.push({ id: i, locale: e.type, name: '' })
          i++
        }
      })
      this.form.localeList = localeList
    },

    validatorLocaleName() {
      let errorMessage = ''
      var localeList = this.form.localeList
      let localeEnum = this.customDict.LocaleEnum
      localeList.forEach((e) => {
        if (!e.name) {
          let localeName = localeEnum.find((locale) => locale.type === e.locale).name
          errorMessage += localeName + this.$t('通用.文本.不能为空') + ';'
        }
      })
      if (errorMessage) {
        this.errorMessage = errorMessage
        return false
      }
      this.errorMessage = ''
      return true
    },
    getTranslation(record) {
      if (!this.form.categoryName) {
        return
      }
      let data = { text: this.form.categoryName, locale: record.locale }
      translation(data).then((response) => {
        record.name = response.data
      })
    },
    limitSort(record) {
      // console.log(i);
      let val = record.sort.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1')
      if (val == null || val == undefined || val == '') {
        val = 0
      }
      if (val > 21474836) {
        val = 21474836
      }
      record.sort = val
    },
    //多语言集成
  },
}
</script>
